import { ActionType } from '../../../../../framework/editor/src/js/constants/common-action-type';
import { actionCallBack } from '../../../../../framework/frame/components/top-menu/top-menu-action';
import { getUrlParameter, removeURLParameter } from '@src/slide/infrastructure/module/independent/url/param-operation';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IUrlParamManager, IUrlParamManagerServiceDelegates } from './url-param-manager.interface';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { resetDefaultTdwData } from '@tencent/tencent-doc-report';
import { IBaseEditorExtensionService } from '@src/slide/application/service/edit-extension/core/editor/base/interface';

// 这里复用一下menu的方法，因此要使用menu的方法id
const MenuActions = {
    authPanel: ActionType.PERMISSION_SETTING,
    advanceAuth: ActionType.ADVANCED_PERMISSION,
    waterMark: ActionType.SET_WATER_MARK,
    // share: ,
    transfer: ActionType.TRANSFER_OWNERSHIP,
    browseRecord: ActionType.BROWSE_RECORD,
};

// 只有owner可以执行的方法合集
const OwnerActions = [
    ActionType.PERMISSION_SETTING,
    ActionType.ADVANCED_PERMISSION,
    ActionType.SET_WATER_MARK,
    ActionType.TRANSFER_OWNERSHIP,
    ActionType.TRANSFER_OWNERSHIP_WEWORK,
    ActionType.BROWSE_RECORD,
];

// 只要拥有edit编辑权限就可以执行的方法合集
const EditorActions = [
    'version',
    'history',
];

// 只要拥有read查看权限就可以执行的方法合集
const ReaderActions = [
    'share',
];

/**
 * 支持按url参数打开特定面板的功能
 */
export default class UrlParamManager implements IUrlParamManager {
    private extensionService: IBaseEditorExtensionService;
    private historyManager?: IHistoryManager;

    public init(menuManager: IMenuManager): void {
        // 从列表页跳转过来时，页面加载完毕后，根据url的参数判断应该打开哪个侧边栏
        // 由于修订记录不属于FC组件，因此页面数据就绪后判断是否具有相关权限后即可打开
        SlideDataServices.SlideAppService.promise().then((slideAppService) => {
            slideAppService.onReady(() => {
                const panelId = getUrlParameter('actionType');
                if (!panelId) {
                    return;
                }
                this.openPanelByUrlParam(panelId, menuManager);
            });
        });
    }

    public setServiceDelegates(serviceDelegates: IUrlParamManagerServiceDelegates) {
        this.extensionService = serviceDelegates.extensionService;
        this.historyManager = serviceDelegates.historyManager;
    }

    /**
     * 文档数据就绪后，调用此方法，判断是否需要打开相应面板
     * @param {*} panelId 面板的id，与列表页相约定，为url的"actionType"参数
     */
    private openPanelByUrlParam(panelId: string, menuManager) {
        const { privilegeAttribute } = this.extensionService.getDocInfo() || { };
        const actionId = MenuActions[panelId] || panelId;
        if (!actionId) {
            return;
        }
        // 只有owner拥有者才能执行的动作
        if (SlideDataServices.DocInfoManager()?.isOwner && OwnerActions.some(item => item === actionId)) {
            actionCallBack(actionId, menuManager, {});
        }
        // 只要拥有edit编辑权限就可以执行的方法
        if (privilegeAttribute.can_edit && EditorActions.some(item => item === actionId)) {
            this.paramAction(actionId);
        }
        // 只要拥有read查看权限就可以执行的方法
        if (privilegeAttribute.can_read && ReaderActions.some(item => item === actionId)) {
            this.paramAction(actionId);
        }
        // 只要有参数，就要清除url参数
        const url = window.location.href;
        const newUrl = removeURLParameter(url, 'actionType');
        history.replaceState(null, '', newUrl);
    }

    /**
     * 一些需要单独调用的方法放在这里做一个集合
     * @param {*} panelId 面板的id
     */
    private paramAction(panelId: string) {
        if (panelId === 'version' || panelId === 'history') {
            this.historyManager?.show({
                activeId: panelId,
            });
        } else if (panelId === 'share') {
            this.extensionService.getCallBackAdapter()?.showShareModule?.();
        }
    }
}
